import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import loadable from '@loadable/component';
import { Container } from 'reactstrap';
import HelmetMeta from '../../components/HelmetMeta';
import HelmetTitle from '../../components/HelmetTitle';
import HelmetStyle from '../../components/HelmetStyle';
import HelmetScript from '../../components/HelmetScript';
import HelmetHead from '../../components/HelmetHead';
import Loader from '../../components/Loader';
import UnderConstruction from '../../components/UnderConstruction';
import './TermsPage.scss';
import NoMatch from '../NoMatch';
import config from '../../config';
import PageTitle from '../../widgets/PageTitle/PageTitle';
import {
  usePage,
  useTealium,
  useAdGlare,
  useUnmountResetPage,
  useNotFound,
  useDebounceLoading,
  useDelayJsLoadiing,
  useURLChangeCallback,
} from '../../utils/hookHelper';
import { sanitizedHTML } from '../../utils/Helper';

const TermsPage = (props) => {
  const { dataContent } = props;

  return (
    <div className="termsPage-page">
      <Container>
        <div className="content-part">
          <PageTitle title={dataContent.headline} isFirst />
          <div
            dangerouslySetInnerHTML={{
              __html: sanitizedHTML(dataContent.description),
            }}
          />
          <div
            dangerouslySetInnerHTML={{
              __html: sanitizedHTML(dataContent.content_body),
            }}
          />
        </div>
      </Container>
    </div>
  );
};

export default TermsPage;
